import React, { Fragment, useContext, useEffect, useMemo, useRef, useState } from "react";
import { Link, useLocation, useNavigate, useParams } from "react-router-dom";
import { useNoteAlert } from "../../../Context/pleaseNote";
import { useAuth } from "../../../Context/AuthContext";
import { PaymentSectionPayOnline } from "../../PayOnline/paymentSectionPayOnline";
import Skeleton from "react-loading-skeleton";
import { SubmitOrderNote } from "../../CheckOutNew/Payment/submitOrderNote";
import { useGlobalFunction } from "../../../Context/GlobalFunctionContext";
import { useCheckPoNumberRules } from "../../../Context/hook/useCheckPONumberRules";
import { GlobalContext } from "../../../Context/GlobalContext";
import { SUBMIT_ORDER, SHIPPING_METHOD, PAYMENT_FAILED, getTillBrowserData } from "../../../constants";
import { PAGES } from "../../../routeConfig";
import { useTillReturnBackGuard } from "../../../Context/hook/useTillReturnBackGuard";
import { axiosInstance } from "../../../axios/axiosInstance";
import "./PaymentRequired.css";
import {
  isNumeric,
  isValidArray,
  scrollToTop,
  scrollToFocuse,
  showCardDetails,
  smsNumberChangeClick,
  validateMonthYear,
} from "../../../Layout/Common/common";
import $ from "jquery";
import "datatables.net";
import "datatables.net-responsive";
import { redirectToTill, readTillBackPath } from "../../../Context/hook/tillRedirect";
import {
  stashPayAccountSettleData,
  stashPayAccountUiState,
  takePayAccountUiState,
  usePayAccountTillReturn,
} from "../../../Context/hook/usePayAccountTillReturn";
import { TillSettlingOverlay } from "../../../Layout/Common/tillSettlingOverlay";
import { PaymentSelection } from "./paymentSelection";
import { GuestDetailsForm } from "./guestDetailsForm";
import { showErrorSnackbar } from "../../../utils/snackbarNotifications";

export const PaymentRequired = ({ invoices = [] }) => {
  const tableRef = useRef(null);
  const dtRef = useRef(null);
  const guestFormRef = useRef(null);
  const { showDialogAlert, hideNoteAlert, showNoteAlert, showFlashScreen, showRestrictionAlert } = useNoteAlert();
  const { isAuthenticated, userId, companyId, setUser, setAthuLoading, emailAddress, userName, phoneNumber, role } =
    useAuth();
  const navigate = useNavigate();
  const [billInfo, setBillInfo] = useState(null);
  const { loadStoredCard, sendInvoiceSignal } = useGlobalFunction();

  const history = useNavigate();
  const location = useLocation();
  const paymentData = location.state;
  const { settling, tillReturn } = usePayAccountTillReturn();
  const tillHandledRef = useRef(false);

  useTillReturnBackGuard({
    active: !!tillReturn && !settling,
    backTo: readTillBackPath() || (isAuthenticated ? PAGES.MYACCOUNT : PAGES.HOME),
  });
  const [restoredUi] = useState(() => {
    const stashed = takePayAccountUiState(tillReturn ? tillReturn.transId : null);
    return tillReturn && !tillReturn.isSuccess ? stashed : null;
  });
  const restoreAppliedRef = useRef(false);
  const paymentRestoredRef = useRef(false);
  const restoredRangeRef = useRef(
    restoredUi && (restoredUi.minAmount != null || restoredUi.maxAmount != null)
      ? { min: restoredUi.minAmount, max: restoredUi.maxAmount }
      : null,
  );
  const [paybuttonDisabled, setPaybuttonDisabled] = useState(false);
  const [tillToken, setTillToken] = useState(null);
  const [tillProcess, setTillProcess] = useState(false);
  const [smsNumberCancelClicked, setSmsNumberCancelClicked] = useState(false);
  const { submitOrderMailSend } = useGlobalFunction();
  const checkPoNumberRules = useCheckPoNumberRules();
  const [guestDetail, setGuestDetail] = useState({ name: "", mail: "", phone: "" });

  const divcontainerRef = useRef();
  const { urlref } = useParams();
  const {
    poNumber,
    poNumberRequired,
    poNumberRules,
    selectedPaymentType,
    setSelectedPaymentType,
    deliveryMethod,
    orderCommands,
    shippingMode,
    shippingCode,
    changeShipServiceClicked,
    selectedCard,
    setSelectedCard,
    storedCard,
    promoCode,
    isSubmitOrder,
    newCardSave,
    setNewcardSave,
    setDeliveryMethod,
    smsNumber,
    smsNotificationCancelClicked,
    globalcontext,
  } = useContext(GlobalContext);
  const [paymentType, setPaymentType] = useState("NEWCARD");

  const selectedRef = useRef(new Map());
  const didInitSelectionRef = useRef(false);
  const lastSelectedJsonRef = useRef([]);
  const pushTimeoutRef = useRef(null);

  const pushSelectionToServer = () => {
    if (pushTimeoutRef.current) clearTimeout(pushTimeoutRef.current);
    pushTimeoutRef.current = setTimeout(() => {
      const payload = JSON.stringify(Array.from(selectedRef.current.values()));
      axiosInstance
        .post("PayAccount/UpdateSession", { SelectedInvoice: payload })
        .catch((e) => console.error("UpdateSession failed", e));
    }, 300);
  };
  const searchQueryRef = useRef("");
  const [selectedTotal, setSelectedTotal] = useState(0);
  const [selectedItems, setSelectedItems] = useState([]);
  const [checkedAll, setCheckedAll] = useState(true);
  const [searchQuery, setSearchQuery] = useState("");
  const [minAmount, setMinAmount] = useState(0);
  const [maxAmount, setMaxAmount] = useState(0);
  const minAmountRef = useRef(0);
  const maxAmountRef = useRef(Number.MAX_SAFE_INTEGER);
  const rangeInitializedRef = useRef(false);
  const { dataMin, dataMax } = useMemo(() => {
    if (!Array.isArray(invoices) || invoices.length === 0) return { dataMin: 0, dataMax: 0 };
    const amts = invoices.map((i) => parseFloat(i.amountCharged) || 0);
    return { dataMin: Math.floor(Math.min(...amts)), dataMax: Math.ceil(Math.max(...amts)) };
  }, [invoices]);
  useEffect(() => {
    if (!tableRef.current) return;

    const $table = $(tableRef.current);

    // Prevent double initialization
    if ($.fn.DataTable.isDataTable(tableRef.current)) {
      $table.DataTable().destroy(false);
    }

    function markFirstVisible() {
      $table.find("tbody tr").each(function () {
        const $cells = $(this).children("td").removeClass("orderCustomClass");

        const $firstVisible = $cells
          .filter(function () {
            const $td = $(this);
            return $td.is(":visible") && !$td.hasClass("dtr-hidden");
          })
          .first();

        $firstVisible.addClass("orderCustomClass");
      });
    }

    dtRef.current = $table.DataTable({
      data: [],
      paging: false,
      info: false,
      searching: true,
      responsive: true,
      autoWidth: false,
      destroy: true,
      dom: "lrtip",

      columns: [
        {
          data: "status",
          defaultContent: "",
          render: function (data) {
            if (!data) return "";
            const status = String(data).toLowerCase().replaceAll(" ", "");
            return `<span class="status_label status-${status}"><p>${String(data)}</p></span>`;
          },
        },

        {
          data: "invoiceDate",
          defaultContent: "",
          render: function (data) {
            if (!data) return "";

            const date = new Date(data);

            if (isNaN(date)) return data;

            const day = String(date.getDate()).padStart(2, "0");
            const month = String(date.getMonth() + 1).padStart(2, "0");
            const year = date.getFullYear();

            return `${day}-${month}-${year}`;
          },
        },

        { data: "invoiceNo", defaultContent: "" },

        { data: "orderRef", defaultContent: "" },

        {
          data: "pdfkey",
          orderable: false,
          defaultContent: "",
          render: function (data, type, row) {
            if (!row.invoiceNo || row.invoiceNo === "0") {
              return "";
            }

            return `
            <a
              class="HyperLink2"
              href="javascript:void(0)"
              data-pdfkey="${data}"
              data-invoiceno="${row.invoiceNo}"
            >
              <img
                height="24"
                src="https://cdn.wes.com.au/wes/icons/Pdf.png"
                alt="View Invoice"
              />
            </a>
          `;
          },
        },

        {
          data: "amountCharged",
          defaultContent: "",
          render: function (data) {
            if (!data) return "$0.00";
            return `<b>$ ${parseFloat(data).toFixed(2)}</b>`;
          },
        },
        {
          data: null,
          orderable: false,
          defaultContent: "",
          render: function (data, type, row) {
            const isChecked = selectedRef.current.has(String(row.invoiceNo)) ? "checked" : "";
            return `
            <div class="form-check custom-check loginRemember">
                  <div class="signature-req-input">
                    <input
                      type="checkbox" name="invoiceCheck-${row.invoiceNo}" id="invoiceCheck-${row.invoiceNo}"
                      class="form-check-input invoice-check"
                value="${row.invoiceNo}"
                ${isChecked}
              /> 
             <label class="form-check-label" for="invoiceCheck-${row.invoiceNo}">
                    Pay
                  </label>
            </div>
            </div> 
          `;
          },
        },
      ],

      columnDefs: [{ targets: [4], className: "text-center" }],

      initComplete: function () {
        markFirstVisible();
      },
    });

    $table.on("change", ".invoice-check", function () {
      const id = String($(this).val());
      const rowData = dtRef.current?.row($(this).closest("tr")).data();
      const amount = String(rowData?.amountCharged ?? "");

      if (this.checked) {
        selectedRef.current.set(id, { invoice: id, amount });
      } else {
        selectedRef.current.delete(id);
      }

      recomputeTotal();
      pushSelectionToServer();
    });

    $table.on("click", ".HyperLink2", async function (e) {
      e.preventDefault();
      const $link = $(this);
      debugger;
      const invoiceNo = $(this).data("invoiceno");
      if (!invoiceNo) {
        showErrorSnackbar("Invoice number not found");
        return;
      }

      const $img = $link.find("img");
      const originalSrc = $img.attr("src");
      const loadingSrc = "https://cdn.wes.com.au/wes/images/loading.gif";

      $img.attr("src", "https://cdn.wes.com.au/wes/icons/Pdf.png");
      $link.css("pointer-events", "none");

      try {
        await sendInvoiceSignal(invoiceNo, invoiceNo, "PAYACCOUNT");

        $img.attr("src", loadingSrc);
      } finally {
        $img.attr("src", originalSrc);
        $link.css("pointer-events", "");
      }
    });

    // OR-filter on status / invoiceNo / orderRef when query >= 3 chars,
    // AND-combined with the amount range filter.
    const customSearch = (settings, _searchData, _index, rowData) => {
      if (settings.nTable !== tableRef.current) return true;
      const q = (searchQueryRef.current || "").trim().toLowerCase();
      const status = String(rowData?.status ?? "").toLowerCase();
      const inv = String(rowData?.invoiceNo ?? "").toLowerCase();
      const po = String(rowData?.orderRef ?? "").toLowerCase();
      const textMatch = q.length < 3 || status.includes(q) || inv.includes(q) || po.includes(q);
      const amt = parseFloat(rowData?.amountCharged) || 0;
      const amountMatch =
        amt >= (minAmountRef.current ?? 0) && amt <= (maxAmountRef.current ?? Number.MAX_SAFE_INTEGER);
      return textMatch && amountMatch;
    };
    $.fn.dataTable.ext.search.push(customSearch);

    return () => {
      $table.off(".dt");
      $table.off("change");
      $table.off("click", ".HyperLink2");

      if (pushTimeoutRef.current) {
        clearTimeout(pushTimeoutRef.current);
        pushTimeoutRef.current = null;
      }

      const idx = $.fn.dataTable.ext.search.indexOf(customSearch);
      if (idx !== -1) $.fn.dataTable.ext.search.splice(idx, 1);

      if (dtRef.current) {
        dtRef.current.destroy(false);
        dtRef.current = null;
      }
    };
  }, []);
  useEffect(() => {
    const dt = dtRef.current;
    if (!dt) return;
    dt.clear();
    if (Array.isArray(invoices) && invoices.length) dt.rows.add(invoices);
    const validIds = new Set((invoices || []).map((i) => String(i.invoiceNo)));
    selectedRef.current.forEach((_v, id) => {
      if (!validIds.has(id)) selectedRef.current.delete(id);
    });

    const applyRestore =
      restoredUi != null && !restoreAppliedRef.current && Array.isArray(invoices) && invoices.length > 0;

    if (!didInitSelectionRef.current && Array.isArray(invoices) && invoices.length) {
      const stashedSelection = restoredUi != null && isValidArray(restoredUi.selected) ? restoredUi.selected : null;
      selectedRef.current = stashedSelection
        ? new Map(
            stashedSelection
              .filter((s) => validIds.has(String(s.invoice)))
              .map((s) => [String(s.invoice), { invoice: String(s.invoice), amount: String(s.amount ?? "") }]),
          )
        : new Map(
            invoices.map((i) => [
              String(i.invoiceNo),
              { invoice: String(i.invoiceNo), amount: String(i.amountCharged) },
            ]),
          );
      didInitSelectionRef.current = true;
    }
    pushSelectionToServer();

    const clampAmount = (value, fallback) => {
      const parsed = Number(value);
      if (value == null || isNaN(parsed)) return fallback;
      return Math.min(Math.max(parsed, dataMin), dataMax);
    };
    const restoredRange = restoredRangeRef.current;
    const nextMin = restoredRange ? clampAmount(restoredRange.min, dataMin) : dataMin;
    const nextMax = restoredRange ? clampAmount(restoredRange.max, dataMax) : dataMax;

    minAmountRef.current = nextMin;
    maxAmountRef.current = nextMax;
    setMinAmount(nextMin);
    setMaxAmount(nextMax);

    if (applyRestore) {
      const stashedQuery = restoredUi.searchQuery || "";
      searchQueryRef.current = stashedQuery;
      setSearchQuery(stashedQuery);
      restoreAppliedRef.current = true;
    }

    dt.draw(true);
    try {
      $(tableRef.current)
        .find(".invoice-check")
        .each(function () {
          $(this).prop("checked", selectedRef.current.has(String($(this).val())));
        });
    } catch (e) {}

    recomputeTotal();
  }, [invoices, dataMin, dataMax]);
  useEffect(() => {}, [guestDetail]);
  const renderTable = (raw) => {
    const dt = dtRef.current;
    if (!dt) return;
    dt.clear();
    if (Array.isArray(raw)) dt.rows.add(raw);
    dt.draw(true);
  };

  useEffect(() => {
    const dt = dtRef.current;
    if (!dt) return;
    dt.column(2).search("");
    searchQueryRef.current = searchQuery;
    dt.draw();
  }, [searchQuery]);

  useEffect(() => {
    const dt = dtRef.current;
    if (!dt) return;
    // Skip the very first run, which fires with the default [0,0] range before
    // it has been seeded from the data. Pruning here would deselect every
    // invoice and leave the "Pay Invoice" header checkbox unchecked even though
    // all invoices start selected. The data effect has already seeded the refs.
    if (!rangeInitializedRef.current) {
      rangeInitializedRef.current = true;
      return;
    }
    minAmountRef.current = minAmount;
    maxAmountRef.current = maxAmount;
    dt.rows().every(function () {
      const r = this.data();
      const amt = parseFloat(r.amountCharged) || 0;
      if (amt < minAmount || amt > maxAmount) {
        selectedRef.current.delete(String(r.invoiceNo));
      }
    });
    dt.draw();
    recomputeTotal();
    pushSelectionToServer();
  }, [minAmount, maxAmount]);

  useEffect(() => {
    if (changeShipServiceClicked == false) scrollToFocuse(divcontainerRef.current, 500, 200);

    return () => {
      setSelectedPaymentType(null);
      setNewcardSave(false);
    };
  }, [changeShipServiceClicked]);

  useEffect(() => {
    if (selectedPaymentType) {
      setTillToken(null);
    }
  }, [selectedPaymentType]);

  useEffect(() => {
    if (isAuthenticated) loadStoredCard();
  }, [isAuthenticated]);

  useEffect(() => {
    if (settling || !restoredUi || paymentRestoredRef.current) return;

    const stashedType = restoredUi.paymentType === "MYWALLET" ? "MYWALLET" : "NEWCARD";
    const walletCard =
      stashedType === "MYWALLET" && isValidArray(storedCard)
        ? storedCard.find((c) => String(c.cardUuid) === String(restoredUi.cardUuid) && c.IsExpired == false)
        : null;

    if (stashedType === "MYWALLET" && !walletCard && !storedCard) return;

    paymentRestoredRef.current = true;

    if (walletCard) {
      setSelectedCard(walletCard);
      setSelectedPaymentType("MYWALLET");
    } else {
      setSelectedPaymentType("NEWCARD");
      showCardDetails();
    }

    scrollToFocuse(document.getElementById("pay-card"), 800, 150);
  }, [settling, restoredUi, storedCard]);

  useEffect(() => {
    if (settling || !tillReturn || tillReturn.isSuccess || tillHandledRef.current) return;
    tillHandledRef.current = true;
    showDialogAlert({
      content: PAYMENT_FAILED.content,
      title: PAYMENT_FAILED.title,
      primaryBtn: { caption: "Try new card", onClick: paymentDeclineFunction },
      scondaryBtn: { caption: "Ok", onClick: hideNoteAlert },
    });
  }, [settling, tillReturn]);

  const handlePayNowClick = () => {
    if (String(deliveryMethod).includes(SHIPPING_METHOD[2]) && !smsNumber && smsNumberCancelClicked == false) {
      showDialogAlert({
        content: "Please provide a mobile number to receive SMS notification or proceed without SMS notification.",
        title: "SMS Notification Not Provided",
        primaryBtn: {
          caption: "Provide Mobile Number",
          onClick: () => smsNumberChangeClick(),
        },
        scondaryBtn: {
          caption: "Proceed without SMS",
          onClick: () => {
            setSmsNumberCancelClicked(true);
            checkOrderNumber();
          },
        },
      });
    } else {
      checkOrderNumber();
    }
  };

  const checkOrderNumber = () => {
    PayNow();
  };

  const paymentDeclineFunction = () => {
    setTillToken(null);
    setSelectedPaymentType("NEWCARD");
    $("#newCardPayment").click();
    showCardDetails();
    hideNoteAlert();
  };

  const getCardUuid = () => {
    if (selectedCard && selectedPaymentType == "MYWALLET") {
      return selectedCard.cardUuid;
    } else {
      return "";
    }
  };

  const ProcessPayment = (trntoken) => {
    const selectedJson = Array.from(selectedRef.current.values());
    const selectedInvoiceNos = selectedJson.map((s) => s.invoice);
    lastSelectedJsonRef.current = selectedJson;

    if (selectedInvoiceNos.length === 0 || selectedTotal <= 0) {
      showFlashScreen(false);
      showNoteAlert("Please select at least one invoice to pay.");
      return;
    }

    const invoiceByNo = new Map((invoices || []).map((i) => [String(i.invoiceNo), i]));
    const jsonDataPayload = selectedJson.map((s) => {
      const src = invoiceByNo.get(String(s.invoice));
      const pref = src && src.paymentRef != null ? String(src.paymentRef).trim() : "";
      return {
        invoice: pref.length > 0 ? pref : String(s.invoice),
        amount: s.amount,
      };
    });

    var params = {
      UserID: userId ? String(userId) : "",
      CompanyID: companyId ? String(companyId) : "",
      PaymentAmount: String(selectedTotal.toFixed(2)),
      ExpDate: "",
      Token: trntoken,
      SCNumber: "",
      urlRef: urlref || "",
      cardType: selectedPaymentType,
      isSaveCard: newCardSave,
      uuid: getCardUuid(),
      InvoiceNo: selectedInvoiceNos.join(","),
      JsonData: JSON.stringify(jsonDataPayload),
      browserData: getTillBrowserData(),
    };

    if (selectedPaymentType == "MYWALLET" || selectedPaymentType == "NEWCARD") {
      params.paymentMode = "TI";
    }
    axiosInstance
      .post("PayAccount/TillPaymentProcess", params)
      .then((response) => {
        if (response.data != "" && response.data != null) {
          showFlashScreen(false);
          if (response.data.Status == "Success") {
            if (params.paymentMode == "TI") {
              if (!response.data.RedirectTo || !response.data.ReferenceId) {
                showNoteAlert("Payment Process Failed. Please try again.");
                showFlashScreen(false);
                return;
              }
              stashPayAccountSettleData({
                transId: response.data.ReferenceId,
                companyId: companyId != null ? String(companyId) : "0",
                userId: userId != null ? String(userId) : "",
                userName: userName ?? guestDetail?.name ?? "",
                email: emailAddress ?? guestDetail?.mail ?? "",
                phone: phoneNumber ?? guestDetail?.phone ?? "",
                totalAmount: String(selectedTotal.toFixed(2)),
              });
              stashPayAccountUiState({
                transId: response.data.ReferenceId,
                selected: selectedJson,
                searchQuery,
                minAmount,
                maxAmount,
                guest: guestDetail,
                paymentType: selectedPaymentType,
                cardUuid: selectedCard ? selectedCard.cardUuid : null,
              });
              showFlashScreen({
                messages: ["Taking you to the secure payment page…", "Please do not refresh or close this window."],
              });
              redirectToTill(response.data.RedirectTo);
            }
          } else if (response.data.Status == "Error01") {
            history(PAGES.ORDER_DETAIL);
            showFlashScreen(false);
          } else if (response.data.Status == "Error02") {
            showFlashScreen(false);
            showNoteAlert("Your price code has been changed. Please verfiy the price and continue.");
            window.location.reload();
          } else {
            showNoteAlert("Payment Process Failed. Please try again.");
            showFlashScreen(false);
          }
        }
      })
      .catch((error) => {
        showFlashScreen(false);
      });
  };

  // Google Pay: run the same guest-details validation as "Pay Now" (plus an invoice-selected check)
  // before opening the Google Pay sheet. `proceed` opens the sheet; only called when validation passes.
  const handleGooglePayBeforePay = async (proceed) => {
    if (!isAuthenticated && guestFormRef.current) {
      const form = guestFormRef.current;
      form.setTouched({ guestName: true, guestEmail: true, guestPhone: true });
      const errors = await form.validateForm();
      if (Object.keys(errors).length > 0) {
        showNoteAlert("Please fill in your contact details before proceeding.");
        return;
      }
    }
    if (selectedTotal <= 0) {
      showNoteAlert("Please select at least one invoice to pay.");
      return;
    }
    proceed();
  };

  // Google Pay charge: same invoice payload as ProcessPayment, but the token comes from the Google Pay
  // sheet and is charged directly through Till (no hosted redirect / popup).
  const processGooglePayToken = (googlePayToken) => {
    const selectedJson = Array.from(selectedRef.current.values());
    const selectedInvoiceNos = selectedJson.map((s) => s.invoice);

    if (selectedInvoiceNos.length === 0 || selectedTotal <= 0) {
      showFlashScreen(false);
      showNoteAlert("Please select at least one invoice to pay.");
      return;
    }

    const invoiceByNo = new Map((invoices || []).map((i) => [String(i.invoiceNo), i]));
    const jsonDataPayload = selectedJson.map((s) => {
      const src = invoiceByNo.get(String(s.invoice));
      const pref = src && src.paymentRef != null ? String(src.paymentRef).trim() : "";
      return {
        invoice: pref.length > 0 ? pref : String(s.invoice),
        amount: s.amount,
      };
    });

    showFlashScreen({
      messages: [
        "Processing your invoice, please wait…",
        "Confirming your Google Pay details with Till…",
        "Please do not refresh or close this window.",
      ],
    });

    var params = {
      UserID: userId ? String(userId) : "",
      CompanyID: companyId ? String(companyId) : "",
      PaymentAmount: String(selectedTotal.toFixed(2)),
      Token: "",
      urlRef: urlref || "",
      cardType: "TILLGOOGLEPAY",
      isSaveCard: false,
      uuid: "",
      InvoiceNo: selectedInvoiceNos.join(","),
      JsonData: JSON.stringify(jsonDataPayload),
      googlePayToken: googlePayToken,
      userName: guestDetail?.name || "",
      email: isAuthenticated ? emailAddress || "" : guestDetail?.mail || "",
      phone: guestDetail?.phone || "",
    };

    axiosInstance
      .post("PayAccount/ProcessGooglePay", params)
      .then((response) => {
        const data = typeof response?.data === "string" ? JSON.parse(response.data) : response?.data;
        showFlashScreen(false);
        if (!data?.successful) {
          if (data?.redirectUrl) {
            window.location.href = data.redirectUrl; // 3DS challenge
            return;
          }
          showNoteAlert(data?.error || "Payment Process Failed. Please try again.");
          return;
        }
        history(PAGES.PAYACCOUNT_SUCCESS + "/" + data.transactionId + (urlref ? "/" + urlref : ""));
      })

      .catch((error) => {
        showFlashScreen(false);
        showNoteAlert("We couldn't reach Till to complete your payment. Please check your connection and try again.");
      });
  };

  const PayNow = async () => {
    // Guest contact details are mandatory when the user is not logged in.
    if (!isAuthenticated && guestFormRef.current) {
      const form = guestFormRef.current;
      form.setTouched({ guestName: true, guestEmail: true, guestPhone: true });
      const errors = await form.validateForm();
      if (Object.keys(errors).length > 0) {
        showNoteAlert("Please fill in your contact details before proceeding.");
        return;
      }
    }

    showFlashScreen({
      messages: ["Processing your invoice, please wait…", "Please do not refresh or close this window."],
    });
    if (selectedPaymentType == "NEWCARD") {
      GenerateToken();
    } else if (selectedPaymentType == "MYWALLET") {
      ProcessPayment("");
    } else {
      showFlashScreen(false);
      showNoteAlert("Please select a valid payment method before proceeding.");
    }
  };

  const GenerateToken = () => {
    var validation = true;
    var cardName = document.getElementById("cardName")?.value ?? "";
    var cardExp = document.getElementById("cardExp")?.value ?? "";

    if (isNumeric(cardName) == false) {
      showFlashScreen(false);
      $("#newcardNameError").css("display", "block");
      $("#cardName").focus();
      validation = false;
    }
    var isv = 1;
    if (!validateMonthYear(cardExp)) {
      isv = 0;
      showFlashScreen(false);
      $("#newcardExpError").css("display", "block");
      if (validation == false) $("#cardExp").focus();
      validation = false;
    }
    if (validation) {
      var splitval = cardExp.split("/");
      var data = {
        card_holder: cardName,
        month: splitval[0],
        year: "20" + splitval[1],
      };
      window.till.tokenize(
        data,
        function (token, cardData) {
          var isdefault = "0";
          setTillToken(token);
          ProcessPayment(token);
        },
        function (errors) {
          if (errors) {
            if (isValidArray(errors)) {
              var errmsg = errors[0].message;
              if (errmsg) {
                showNoteAlert(errmsg);
              } else {
                showNoteAlert("Payment process failed. Please try again.");
              }
            }
          }
          showFlashScreen(false);
        },
      );
    } else {
      showNoteAlert("Please fill in the mandatory fields and try again.");
      showFlashScreen(false);
    }
  };
  const updateHeaderCheckbox = () => {
    const dt = dtRef.current;

    if (!dt) return;

    const totalRows = dt.rows({ filter: "applied" }).count();
    let checkedRows = 0;

    dt.rows({ filter: "applied" }).every(function () {
      if (selectedRef.current.has(String(this.data().invoiceNo))) {
        checkedRows += 1;
      }
    });

    const allChecked = totalRows > 0 && checkedRows === totalRows;
    setCheckedAll(allChecked);
  };
  const recomputeTotal = () => {
    const dt = dtRef.current;

    if (!dt) {
      setSelectedItems([]);
      setSelectedTotal(0);
      return;
    }

    // Build the chosen-invoices array [{ invoice, amount }] from the visible
    // (filter-applied) rows that are selected, and total their amounts.
    const items = [];
    let sum = 0;

    dt.rows({ filter: "applied" }).every(function () {
      const row = this.data();
      const id = String(row.invoiceNo);

      if (selectedRef.current.has(id)) {
        const amount = parseFloat(row.amountCharged) || 0;
        items.push({ invoice: id, amount: amount.toFixed(2) });
        sum += amount;
      }
    });

    setSelectedItems(items);
    setSelectedTotal(sum);

    updateHeaderCheckbox();
  };
  return (
    <Fragment>
      <TillSettlingOverlay show={settling} message="Confirming your payment..." />
      <div className="invoice-filters myaccount-overview">
        <div className="row">
          <div className="col-lg-12">
            <div className="myAcc-list">
              <h2>Invoices Awaiting Payment</h2>
            </div>
            <div className="invoice-acc-search py-3">
              <div className="input-group orders-search">
                <i className="fa-solid fa-magnifying-glass"></i>
                <input
                  type="text"
                  className="form-control"
                  aria-label="Username"
                  aria-describedby="basic-addon1"
                  placeholder="Search"
                  value={searchQuery}
                  onChange={(e) => setSearchQuery(e.target.value)}
                />
              </div>
              <div className="amount-range-filter" style={{ width: "290px" }}>
                <div className="amount-range-slider">
                  <div className="amount-range-track" />
                  <div
                    className="amount-range-progress"
                    style={{
                      left: dataMax === dataMin ? "0%" : `${((minAmount - dataMin) / (dataMax - dataMin)) * 100}%`,
                      right: dataMax === dataMin ? "0%" : `${(1 - (maxAmount - dataMin) / (dataMax - dataMin)) * 100}%`,
                    }}
                  />
                  <input
                    type="range"
                    min={dataMin}
                    max={dataMax}
                    step="1"
                    value={minAmount}
                    disabled={dataMax === dataMin}
                    onChange={(e) => {
                      restoredRangeRef.current = null;
                      setMinAmount(Math.min(Number(e.target.value), maxAmount));
                    }}
                  />
                  <input
                    type="range"
                    min={dataMin}
                    max={dataMax}
                    step="1"
                    value={maxAmount}
                    disabled={dataMax === dataMin}
                    onChange={(e) => {
                      restoredRangeRef.current = null;
                      setMaxAmount(Math.max(Number(e.target.value), minAmount));
                    }}
                  />
                </div>
                <div className="amount-range-bounds">
                  <span className="amount-range-start">
                    Start: <b>$ {Number(minAmount).toFixed(2)}</b>
                  </span>
                  <span className="amount-range-end">
                    End: <b>$ {Number(maxAmount).toFixed(2)}</b>
                  </span>
                </div>
              </div>
            </div>
            <div className="table-responsive">
              <table
                ref={tableRef}
                className="table table-striped display nowrap orderlist-table"
                style={{ width: "100%", overflow: "hidden" }}
              >
                <thead>
                  <tr>
                    <th>Status</th>
                    <th>Invoice Date</th>
                    <th>Invoice No</th>
                    <th>Customer po#</th>
                    <th>
                      View <br />
                      Invoice
                    </th>
                    <th>
                      <b>Amount Owing</b>
                    </th>
                    <th>
                      <div className="form-check custom-check loginRemember">
                        <div className="signature-req-input">
                          <input
                            className="form-check-input"
                            type="checkbox"
                            name="invoiceCheck"
                            id="invoice-check-all"
                            checked={checkedAll}
                            onChange={(e) => {
                              const isChecked = e.target.checked;
                              setCheckedAll(isChecked);
                              if (isChecked) {
                                dtRef.current.rows({ filter: "applied" }).every(function () {
                                  const d = this.data();
                                  const id = String(d.invoiceNo);
                                  selectedRef.current.set(id, { invoice: id, amount: String(d.amountCharged ?? "") });
                                });
                              } else {
                                dtRef.current.rows({ filter: "applied" }).every(function () {
                                  selectedRef.current.delete(String(this.data().invoiceNo));
                                });
                              }

                              $(tableRef.current).find("tbody tr:visible .invoice-check").prop("checked", isChecked);

                              recomputeTotal();
                              pushSelectionToServer();
                            }}
                          />
                        </div>
                        <label className="form-check-label" for="invoiceCheck">
                          Pay Invoice
                        </label>
                      </div>
                    </th>
                  </tr>
                </thead>
                <tbody />
              </table>
            </div>
            {invoices.length === 0 ? (
              <div style={{ width: "100%", marginTop: "20px" }}>
                <Skeleton count={5} height={40} style={{ marginBottom: "10px" }} />
              </div>
            ) : (
              <Fragment>
                {!isAuthenticated && (
                  <GuestDetailsForm
                    setGuestDetail={setGuestDetail}
                    formRef={guestFormRef}
                    initialDetail={restoredUi ? restoredUi.guest : null}
                  />
                )}
                <PaymentSelection
                  googlePayAmount={selectedTotal}
                  onGooglePayBeforePay={handleGooglePayBeforePay}
                  onGooglePayToken={processGooglePayToken}
                />
                <div className="total-amount-checkout">
                  <p>Total {selectedItems.length > 0 ? `(${selectedItems.length} selected)` : ""}</p>
                  <p>$ {selectedTotal.toFixed(2)}</p>
                </div>
                {selectedPaymentType != "TILLGOOGLEPAY" && (
                  <div className="checkout-button pay-now-checkout">
                    <Link className="return-to-cart d-none d-md-block"></Link>
                    <div className="button-effect">
                      <button className="btn btn-products btn-addcart" onClick={PayNow} disabled={selectedTotal <= 0}>
                        Pay Now
                      </button>
                    </div>
                  </div>
                )}
              </Fragment>
            )}
          </div>
        </div>
      </div>
    </Fragment>
  );
};
